export default __webpack_public_path__ + "static/media/light_blue_material_design_loading.6497b438.gif";